import FilterSection from '@/templates/02-components/subcomponents/_news-filter-section/mando-ui.news-filter-section';

const mediaQuery = window.matchMedia('(min-width: 61.25em)');
const newsFilter = document.querySelector('.js-news-filter');
const newsFilterSections = newsFilter.querySelectorAll('.js-news-filter__section');
const resetFilters = document.querySelector('.js-reset-filters');

function instatiateSections() {
  newsFilterSections.forEach((element) => {
    const filterSection = new FilterSection({
      body: element.querySelector('.js-news-filter__item-body'),
      container: element,
      mediaQuery,
      trigger: element.querySelector('.js-news-filter__trigger'),
    });
    filterSection.init();
  });
}

function resetForm() {
  const url = window.location.href.split('?')[0];
  window.history.pushState('name', '', url);

  location.reload();
}

function init() {
  if (newsFilter) {
    instatiateSections();
    resetFilters.addEventListener('click', resetForm);
  }
}

export default init;
